import axios from "axios";

const bizApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api/business`,
  withCredentials: true,
});

let refreshing = null;

bizApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retried && !url.includes("/auth/")) {
      original._retried = true;
      try {
        refreshing = refreshing || bizApi.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return bizApi(original);
      } catch {
        // refresh failed — caller receives the original 401
      }
    }
    return Promise.reject(error);
  }
);

export const apiError = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const msg = detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
    return msg || fallback;
  }
  return fallback;
};

export default bizApi;
